/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React,{ Component } from 'react';
import SalesRep from './OrderDetailsComponents/SalesRep';
import CourseInformation from './OrderDetailsComponents/CourseInformation';
import PropTypes from 'prop-types';
import ModalDialog from '../../widgets/ModalDialog/ModalDialogLink';
import SchoolChangeModal from "./OrderDetailsComponents/InstitutionChangeComponent/SchoolChangeModal";
import moment from 'moment';
import {InstructorComponent} from "./OrderDetailsComponents/InstructorComponenent";
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';

export default class OrderDetails extends Component {
    static get propTypes() {
        return {
            activeCollection: PropTypes.object.isRequired,
            orderDetails: PropTypes.object.isRequired,
            setComponent: PropTypes.func,
            saveInstructorContact: PropTypes.func,
            searchInstructorInfo: PropTypes.func
        };
    }
    constructor (props) {
        super(props);
        this.state = {
            courseInfoReloadKey: 1

        };
        this.dateChanged = false;
        this.handleSelectOnChange = this.handleSelectOnChange.bind(this);
        this.handleInputUpdates = this.handleInputUpdates.bind(this);
        this.enableSubmit = this.enableSubmit.bind(this);
        this.searchSchoolsByPostalCodeAndOtherOptions = this.searchSchoolsByPostalCodeAndOtherOptions.bind(this);
        this.orderDetails = null;
    }

    componentWillMount(){
        this.props.guardDirtySetActive(false);
    }

    componentWillUnmount() {
        this.props.guardDirtySetActive(false);
        if(this.props.activeCollection.collectionId) {
            this.props.getOrderDetails(this.props.activeCollection.collectionId, this.props.activeCollection.creator);
        }
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("OrderDetails");
        }
        if(this.props.activeCollection.collectionId) {
            this.props.getOrderDetails(this.props.activeCollection.collectionId, this.props.activeCollection.creator);
        }
    }

    componentWillReceiveProps(nextProps){
        if(!this.props.activeCollection.collectionId && nextProps.activeCollection.collectionId){
            this.props.getOrderDetails(nextProps.activeCollection.collectionId, nextProps.activeCollection.creator);
        }
        if(this.dateChanged){
            this.setState({courseInfoReloadKey: this.state.courseInfoReloadKey+1});
            this.dateChanged = false;
        }

    }

    handleSelectOnChange(event){
        this.props.setOrgUni(event.target.value);
        this.props.guardDirtySetActive(true);
    }

    enableSubmit(enable){
        this.props.guardDirtySetActive(enable);
    }

    handleInputUpdates(type, payload) {
        switch (type) {
            case "courseName": {
                this.props.setCourseName(payload);
                break;
            }
            case "courseNumber": {
                this.props.setCourseNo(payload);
                break;
            }
            case "estimatedEnrollments": {
                this.props.setEstimatedEnrollments(payload);
                break;

            }
            case "courseStart": {
                this.props.setClassStart(payload);
                this.dateChanged = true;
                break;
            }
            case "courseEnd": {
                this.props.setClassEnd(payload);
                this.dateChanged = true;
                break;
            }
            default: {
                break ;
            }
        }
    }

    searchSchoolsByPostalCodeAndOtherOptions(countryCode, postalCode) {
        let options = {
            isNccerCollection: false
        };

        if (this.props.orderDetails && this.props.orderDetails.school.schoolName === 'NCCER') {
            options.isNccerCollection = true;
        }

        return (this.props.searchSchoolsByPostalCode(countryCode, postalCode, options));
    }

    render() {
        const orgList = [];
        const { activeCollection, orderDetails, searchInstructorInfo } = this.props;
        const ShowcontactInfo = orderDetails && orderDetails.contact ?  true: false;
        const {collectionCourseInformation} = this.props.activeCollection;
        return (
            <div className="pe-row order-details-container">
                <div className="order-details-page order-details">
                    <div className='pe-row'>
                        <div className="pe-col-12">
                            <div className='header-margin' >
                                <label className="pe-title--small">Order Details</label>
                            </div>
                        </div>
                    </div>
                    <div className='pe-row'>
                        <div className="pe-col-1">
                            <label className="pe-label--bold">Status</label>
                        </div>
                        <div className="pe-col-10">
                            <label className="pe-label">{this.props.activeCollection.status}</label>
                        </div>
                    </div>
                    <div className='pe-row'>
                        <div className="pe-col-6">
                            <div className="order-info">
                                <div className="row">
                                    <div className="col1">
                                        <label className="pe-label--bold">Submitted</label>
                                    </div>
                                    <div className="col2">
                                        <label className="pe-label">{moment.utc(this.props.activeCollection.publishDate).format('YYYY-MM-DD')}</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col1">
                                        <label className="pe-label--bold">Creator</label>
                                    </div>

                                    <div className="col2">
                                        <label
                                            className="pe-label">{orderDetails.creator ? (orderDetails.creator.firstName + ' ' + orderDetails.creator.lastName) : ''}</label>
                                        <a href={"mailto:" + (orderDetails.creator ? orderDetails.creator.email : '')}> {orderDetails.creator ? orderDetails.creator.email : ''}</a>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col1">
                                        <label className="pe-label--bold">Instructor</label>
                                        {ShowcontactInfo && !UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_instructor_change) && <ModalDialog
                                            trigger={<a href="#">Change</a>}
                                            title="Change Instructor"
                                        >
                                            <InstructorComponent
                                                activeCollection = {activeCollection}
                                                contactInfo = {orderDetails.contact? orderDetails.contact: null}
                                                saveInstructorContact = {this.props.saveInstructorContact}
                                                searchInstructorInfo = {searchInstructorInfo}
                                            />
                                        </ModalDialog>}
                                    </div>

                                    <div className="col2">
                                        <label className="pe-label">{ orderDetails.contact.instructor ? (orderDetails.contact.instructor.firstName + ' ' + orderDetails.contact.instructor.lastName
                                            +   (orderDetails.contact.instructor.id ? orderDetails.contact.instructor.username ?  ' | ' + orderDetails.contact.instructor.username : '' : ' | No Account') ) : ''}</label>
                                        <a className="no-text-decoration" href={"mailto:" + (orderDetails.contact.instructor ? orderDetails.contact.instructor.email : '')} > {orderDetails.contact.instructor ? orderDetails.contact.instructor.email : ''}</a>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col1">
                                        <label className="pe-label--bold">Institution</label>
                                    </div>
                                    <div className="col2 institution-change">
                                        {!UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_institution_change) && <ModalDialog
                                            trigger={<a href="#">Change</a>}
                                            title="Change Institution"
                                            onClose={this.props.onInstitutionModalClose}
                                        >
                                            <SchoolChangeModal
                                                activeCollection = {this.props.activeCollection}
                                                currentUserGeo={this.props.activeCollection.geo ? this.props.activeCollection.geo.code : 'US'}
                                                searchSchoolByPostalCode={this.searchSchoolsByPostalCodeAndOtherOptions}
                                                schoolsList = {this.props.orderDetails.searchedSchools}
                                                saveSelectedSchool={this.props.saveSelectedSchool}
                                            />
                                        </ModalDialog>}
                                    </div>
                                </div>
                                <div className="row institution-name">
                                    <label className="pe-label">{this.props.orderDetails.school.schoolName}</label>
                                </div>
                            </div>
                        </div>
                        <div className="pe-col-6">
                            <SalesRep options ={
                                {
                                    salesRepName: this.props.orderDetails.contact.salesRepresentative ? (this.props.orderDetails.contact.salesRepresentative.firstName + ' ' + this.props.orderDetails.contact.salesRepresentative.lastName) : '',
                                    salesRepEmail: this.props.orderDetails.contact.salesRepresentative ? this.props.orderDetails.contact.salesRepresentative.email : '',
                                    salesRepTerr: this.props.orderDetails.school.territory,
                                    salesRepArea:this.props.orderDetails.school.area
                                }}
                            />
                        </div>
                    </div>
                    <div className='pe-row new-row'>
                        <div className="pe-col-6">
                            <div className="row">
                                <div className="org-unit">
                                    <label className="pe-title--secondary" htmlFor="orgCodes">Org Unit</label>
                                    <div className="pe-select-container">
                                        <select className="pe-selectInput--basic" id="orgCodes" onChange={this.handleSelectOnChange} disabled ={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_org_unit)}>
                                            {this.props.orderDetails.salesForceOrgEntities.map((entity,i)=>{
                                                if(entity.salesForceOrgId === this.props.orderDetails.school.salesForceOrg)
                                                { return <option selected key={i} value={entity.salesForceOrgId}> {entity.salesForceName} </option>;}
                                                else { return <option key={i} value={entity.salesForceOrgId}> {entity.salesForceName} </option>; }
                                            })
                                            }
                                        </select>
                                        <svg aria-hidden="true"
                                            focusable="false"
                                            className="pe-icon--dropdown-open-18">
                                            <use xlinkHref="#dropdown-open-sm-18"></use>
                                        </svg>
                                    </div>
                                </div>
                                <CourseInformation key={this.state.courseInfoReloadKey} options= { {
                                    courseName : collectionCourseInformation ? collectionCourseInformation.courseTitle : '' ,
                                    courseNumber : collectionCourseInformation ? collectionCourseInformation.courseNo : '',
                                    estimatedEnrollment : collectionCourseInformation ? collectionCourseInformation.estimatedQty : '' ,
                                    courseStartDate : collectionCourseInformation ? collectionCourseInformation.classStart : '',
                                    courseEndDate: collectionCourseInformation ? collectionCourseInformation.classEnd: '',
                                    updateInputs: this.handleInputUpdates,
                                    enableSubmit: this.enableSubmit,
                                    courseId: collectionCourseInformation ? collectionCourseInformation.courseId ? collectionCourseInformation.courseId :'' : ''
                                }}/>
                            </div>
                            <div className="row">

                            </div>
                        </div>
                        <div className="pe-col-6">
                            <div className="row">
                                <label className="pe-label--bold">Comments from creator</label>
                                <div className="comments commentbox">
                                    <textarea
                                        className="pe-multiLineText--disabled comments"
                                        id="nope"
                                        cols="30"
                                        rows="5"
                                        disabled value={
                                            this.props.activeCollection.collectionCourseInformation ? this.props.activeCollection.collectionCourseInformation.contactPearsonSupport : ''
                                        }>
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetails.js